const route = [
    {
        path: '/activity/2023shujia/index', //2023暑假预热
        component: function (resolve) {
            require(['VIEWS/activity/2023shujia/index.vue'], resolve);
        }
    },
    {
        path: '/activity/2023shujia/preheat', //2023暑假预热
        component: function (resolve) {
            require(['VIEWS/activity/2023shujia/preheat.vue'], resolve);

        }
    },
    {
        path: '/activity/2023shujia/timing', //2023暑假预热
        component: function (resolve) {
            require(['VIEWS/activity/2023shujia/timing.vue'], resolve);

        }
    },
    {
        path: '/activity/2023shujia/pointsdetail', //2023暑假预积分明细
        component: function (resolve) {
            require(['VIEWS/activity/2023shujia/pointsdetail.vue'], resolve);
        }
    },
    {
        path: '/activity/2023shujia/detail/:sid/:unit_class_id',
        component: function (resolve) {
            require(['VIEWS/activity/2023shujia/detail.vue'], resolve);
        }
    },
]
export default route;
